import React, { useEffect, useState } from 'react';
import { Link } from 'gatsby';
import yaml from 'js-yaml';

import CDNImage from '../cdn-image';

import '../../../styles/common/promos/print-shop-embed.scss';

const PrintShopEmbed = (props) => {
  let printShopData;

  try {
    printShopData = yaml.load(props.dataYaml);
  } catch (e) {
    printShopData = null;
    console.log(e);
  }

  const [selectedPrint, setSelectedPrint] = useState(null);

  const grabPrint = async () => {
    const response = await fetch('/data/shop/all-prints.json')
      .catch((error) => {
        console.error(error);
      });
    const jsonData = await response.json();
    
    const filteredPrints = jsonData.filter(print => {
      if (printShopData && printShopData.print) {
        return print.reference === printShopData.print;
      }

      return false;
    });

    if (filteredPrints.length > 0) {
      setSelectedPrint(filteredPrints[0]);
    } else {
      setSelectedPrint(null);
    }
  };

  useEffect(() => {
    if (!selectedPrint) {
      grabPrint();
    }
  });

  const framedImage = () => {
    let classes = 'print-shop-embed__image-container__print-frame';
    classes += (printShopData.landscape) ? ' landscape' : '';

    return (
      <div className="print-shop-embed__image-container">
        <div className="print-shop-embed__image-container__wrapper">
          {(selectedPrint) ? (
            <CDNImage
              imagePath={ selectedPrint.imageSrc }
              alt={ `Sample Print – ${selectedPrint.name}` }
              className={ classes }
            />
          ) : null}
        </div>
      </div>
    );
  };

  const urlWithTrackingParams = (url) => {
    const trackingParams = 'utm_source=pdr&utm_medium=inpost&utm_campaign=prints&utm_content=banner';

    if (url.indexOf('?') >= 0) {
      return `${url}&${trackingParams}`;
    }

    return `${url}?${trackingParams}`;
  };

  return (
    <div className="print-shop-embed-wrapper">
      <div className="print-shop-embed-stretcher">
        <div className="print-shop-embed">
          <div className="print-shop-embed__image">
            {(printShopData.button) ? (
              <Link
                to={ printShopData.button }
              >
                { framedImage() }
              </Link>
            ) : framedImage() }
          </div>
          <div className="print-shop-embed__text">
            <p className="print-shop-embed__header">
              {(printShopData.singleVariant) ? 
                "Want this image on your wall?"
              :
                "Want these images on your wall?"
              }
            </p>
            <p className="print-shop-embed__message">
              {(printShopData.singleVariant) ? 
                "We’ve the image from this post in our online prints shop—all custom made to the highest standards, framed or unframed, and shipped to your door."
              : 
                "We’ve a selection of images from this post in our online prints shop—all custom made to the highest standards, framed or unframed, and shipped to your door."
              }

            </p>
            {(printShopData.button) ? (
              <div className="print-shop-embed__button-bar">
                <Link
                  className="print-shop-embed__buy-button"
                  to={ urlWithTrackingParams(printShopData.button) }
                >
                  {(printShopData.singleVariant) ? 
                    "Buy Print"
                  :
                    "Buy Prints"
                  }
                </Link>
              </div>
            ) : null}
          </div>
        </div>
      </div>
    </div>
  );
}

export default PrintShopEmbed;